













import {Component, Emit, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class ToggleButtonField extends Vue {
  // props
  @Prop({default: false})
  value!: boolean;
  @Prop({})
  trueButtonLabel!: string;
  @Prop({})
  falseButtonLabel!: string;
  @Prop({})
  disabled!: boolean;

  // computed
  get styleVariables() {
    return {
      '--true-button-label': `"${this.trueButtonLabel}"`,
      '--false-button-label': `"${this.falseButtonLabel}"`,
    };
  }

  // events
  @Emit('input')
  input(event: any): boolean {
    return event.target.checked;
  }

  // lifecycle hook
  // nothing
}
